export default "__VITE_ASSET__81851982__"